export default "__VITE_ASSET__VWoTZ9mm__"